class BaseOutput {
    constructor(message, status_code) {
        this.message = message;
        this.status_code = status_code;
    }
}

export default BaseOutput;